<!-- Calendar Backdrop -->
<div class="fixed inset-0 z-40" (click)="closed.emit()"></div>

<!-- Calendar Dropdown -->
<div
  class="calendar-dropdown absolute z-50 top-full mt-2 left-0 w-full bg-white rounded-2xl shadow-xl shadow-gray-200/50 border border-gray-100 p-4"
>
  <!-- Month / Year Navigation -->
  <div class="flex items-center justify-between mb-3">
    <button
      type="button"
      (click)="prevMonth()"
      class="p-1.5 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
    >
      <lucide-icon
        [img]="icons.ChevronLeft"
        class="w-4 h-4 text-gray-600"
      ></lucide-icon>
    </button>
    <span class="text-sm font-bold text-gray-800">
      {{ monthNames[calendarMonth] }} {{ calendarYear }}
    </span>
    <button
      type="button"
      (click)="nextMonth()"
      class="p-1.5 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
    >
      <lucide-icon
        [img]="icons.ChevronRight"
        class="w-4 h-4 text-gray-600"
      ></lucide-icon>
    </button>
  </div>

  <!-- Weekday Headers -->
  <div class="grid grid-cols-7 mb-1">
    @for (wd of weekDays; track wd) {
      <div class="text-center text-xs font-medium text-gray-400 py-1">
        {{ wd }}
      </div>
    }
  </div>

  <!-- Day Grid -->
  <div class="grid grid-cols-7 gap-0.5">
    @for (day of calendarDays; track $index) {
      <button
        type="button"
        [disabled]="day.isPast && !day.isToday"
        class="aspect-square flex items-center justify-center text-sm rounded-lg transition-all duration-150 relative"
        [class.text-gray-800]="
          day.isCurrentMonth &&
          !day.isSelected &&
          (!day.isPast || day.isToday)
        "
        [class.text-gray-300]="
          (!day.isCurrentMonth || (day.isPast && !day.isToday)) &&
          !day.isSelected
        "
        [class.font-semibold]="day.isToday || day.isSelected"
        [class.text-white]="day.isSelected"
        [class.hover:bg-gray-100]="
          !day.isSelected && (!day.isPast || day.isToday)
        "
        [class.cursor-pointer]="!day.isPast || day.isToday"
        [class.cursor-not-allowed]="day.isPast && !day.isToday"
        [style.backgroundColor]="day.isSelected ? themeColor : ''"
        [style.boxShadow]="
          day.isToday && !day.isSelected
            ? 'inset 0 0 0 1.5px ' + themeColor
            : day.isSelected
              ? '0 2px 8px ' + themeColor + '40'
              : ''
        "
        (click)="selectDate(day)"
      >
        {{ day.date }}
      </button>
    }
  </div>

  <!-- Today Shortcut -->
  <div class="mt-3 pt-3 border-t border-gray-100 flex justify-center">
    <button
      type="button"
      (click)="selectToday()"
      class="text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors cursor-pointer hover:bg-gray-50"
      [style.color]="themeColor"
    >
      Today
    </button>
  </div>
</div>
